var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcNone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-none_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 0C8.055 0 0 8.055 0 18s8.055 18 18 18 18-8.055 18-18S27.945 0 18 0m0 33.75C9.315 33.75 2.25 26.685 2.25 18S9.315 2.25 18 2.25 33.75 9.315 33.75 18 26.685 33.75 18 33.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.13 12.873a1.13 1.13 0 0 0-1.59 0L18 16.413l-3.54-3.54a1.13 1.13 0 0 0-1.59 0 1.13 1.13 0 0 0 0 1.59l3.54 3.54-3.54 3.54a1.13 1.13 0 0 0 0 1.59c.225.225.51.33.795.33s.57-.105.795-.33l3.54-3.54 3.54 3.54c.225.225.51.33.795.33s.57-.105.795-.33a1.13 1.13 0 0 0 0-1.59l-3.54-3.54 3.54-3.54a1.13 1.13 0 0 0 0-1.59"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-none_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export default SvgIcNone;